import { render, staticRenderFns } from "./buzzer-settings.vue?vue&type=template&id=fe241b80&scoped=true&"
import script from "./buzzer-settings.vue?vue&type=script&lang=js&"
export * from "./buzzer-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe241b80",
  null
  
)

export default component.exports